<template>
    <div class="bi-com bi-cb">
        <div class="bi-cb-icon-wrapper">
            <img
                class="img-fluid bi-cb-icon"
                src="../../../assets/icon/radio-active.svg"
                v-show="isActive"
                @click="toggleCheckBox()" />
            <img
                class="img-fluid bi-cb-icon"
                src="../../../assets/icon/radio-inactive.svg"
                v-show="!isActive"
                @click="toggleCheckBox()" />
        </div>
        <label class="bi-cb-lbl">{{textLbl}}</label>
    </div>    
</template>
<script>
export default {
    name: "RadioBox",
    props: {
        //v-model
        value: Boolean,
        //props
        textLbl: String,
        //bus
        busEvent: Object,
    },
    data: function () {
        return {
            isActive: this.value
        };
    },
    mounted: function () {
        //page busEvent.
        this.busEvent.$on('onChange', this.onChange);
        //modal busEvent
    },
    created: function() {
        // this.$emit('update:check', this.isActive);
    },
    methods: {
        toggleCheckBox: function () {
            this.isActive = !this.isActive;
            this.$emit('update:check', this.isActive);
        },
        onChange: function (item) {
            this.isActive = item.value
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/component/baseinput.scss";
</style>